export default "__VITE_ASSET__CG1NuKKX__"